import { render, staticRenderFns } from "./DualCamera.vue?vue&type=template&id=0bba4712&scoped=true"
import script from "./DualCamera.vue?vue&type=script&lang=js"
export * from "./DualCamera.vue?vue&type=script&lang=js"
import style0 from "./DualCamera.vue?vue&type=style&index=0&id=0bba4712&prod&lang=less&scoped=true"
import style1 from "./DualCamera.vue?vue&type=style&index=1&id=0bba4712&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bba4712",
  null
  
)

export default component.exports